import { Set } from '@everyboard/lib';
import { CoordSet } from '../CoordSet';
import { HexagonalUtils } from '../HexagonalUtils';
import { GameState } from './GameState';
export class OpenHexagonalGameState extends GameState {
    pieces;
    width;
    height;
    constructor(pieces, turn) {
        super(turn);
        this.pieces = pieces;
        const scale = this.computeScale();
        this.width = scale.width;
        this.height = scale.height;
        this.pieces.makeImmutable();
    }
    getPieces() {
        return this.pieces;
    }
    getPieceCoords() {
        return this.pieces.getKeyList();
    }
    computeScale() {
        let minWidth = Number.POSITIVE_INFINITY;
        let maxWidth = Number.NEGATIVE_INFINITY;
        let minHeight = Number.POSITIVE_INFINITY;
        let maxHeight = Number.NEGATIVE_INFINITY;
        for (const coord of this.pieces.getKeyList()) {
            minWidth = Math.min(coord.x, minWidth);
            maxWidth = Math.max(coord.x, maxWidth);
            minHeight = Math.min(coord.y, minHeight);
            maxHeight = Math.max(coord.y, maxHeight);
        }
        return {
            width: maxWidth + 1 - minWidth,
            height: maxHeight + 1 - minHeight,
        };
    }
    isOnBoard(coord) {
        return this.pieces.containsKey(coord);
    }
    getOccupiedNeighbors(coord) {
        const neighbors = new CoordSet(HexagonalUtils.getNeighbors(coord));
        return neighbors.filter((neighbor) => {
            return this.pieces.get(neighbor).isPresent();
        });
    }
    getGroups() {
        let visited = new CoordSet();
        let groups = new Set();
        for (const coord of this.pieces.getKeyList()) {
            if (visited.contains(coord) === false) {
                // We will visit all reachable occupied neighbors of this coord
                let group = new CoordSet();
                let toVisit = new CoordSet([coord]);
                while (toVisit.hasElements()) {
                    const nextCoord = toVisit.getAnyElement().get();
                    toVisit = toVisit.removeElement(nextCoord);
                    visited = visited.addElement(nextCoord);
                    group = group.addElement(nextCoord);
                    const occupiedNeighboors = this.getOccupiedNeighbors(nextCoord);
                    const unvisitedOccupiedNeighboors = occupiedNeighboors
                        .filter((neighbor) => visited.contains(neighbor) === false);
                    toVisit = toVisit.union(unvisitedOccupiedNeighboors);
                }
                groups = groups.addElement(group);
            }
        }
        return groups;
    }
}
